// extracted by mini-css-extract-plugin
module.exports = {"CloseBtn":"EGjuVYrTnS90wCY94FS4C"};